export default {
  GetProfile: (data) => window.axios.get("customer/profile", data),
  UpdateProfile: (data) => window.axios.put("customer/profile", data),
  ChangePassword: (data) => window.axios.post("customer/password", data),

  DeleteProfile: (data) => window.axios.post("delete_account", data),
  CustomerReportBug: (data) => window.axios.post("bug-report", data),
};
